
export const GET_RECIPES = 'GET_RECIPES';
export const ADD_RECIPE = 'ADD_RECIPE';
export const DELETE_RECIPE = 'DELETE_RECIPE';
export const UPDATE_RECIPE = 'UPDATE_RECIPE';

export const UPDATE_USER = 'UPDATE_USER';
export const USER_LOADED = 'USER_LOADED';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';